var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({},'div',_vm.$attrs,false),[_vm._t("default",null,{"setDisabled":_vm.setDisabled,"disabled":_vm.disabled})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }